import React from 'react'
import 'dayjs/locale/zh-cn'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import router from '@/router'
import { ThemeProvider } from '@cx/ui'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import duration from 'dayjs/plugin/duration'
import { cxTheme } from './theme'
import './index.css'
import './asset/font/iconfont.js'

dayjs.locale('zh-cn')
dayjs.extend(duration)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

const rootDom = document.getElementById('root')
const root = ReactDOM.createRoot(rootDom as HTMLElement)

root.render(
  <ConfigProvider
    locale={zhCN}
    theme={{
      token: {
        colorPrimary: '#206CFF',
      },
    }}
  >
    <ThemeProvider theme={cxTheme} mode='light'>
      <RouterProvider router={router()} />
    </ThemeProvider>
  </ConfigProvider>,
)
